// central.eu — lucide icon helper.
// Builds a namespaced <svg> node from the lucide UMD's real icon data
// (window.lucide.icons[Name] = [[tag, attrs], ...]). Rendering the node directly
// works inside shadow DOM; Lit inserts the returned SVGElement when interpolated.

const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * Return an SVGElement for a lucide icon by PascalCase name (e.g. 'ArrowRight').
 * Returns '' if lucide has not loaded or the name is unknown.
 */
export function icon(name: string): SVGElement | string {
  const lucide = (window as any).lucide;
  const data = lucide && lucide.icons && lucide.icons[name];
  if (!Array.isArray(data)) return '';

  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('xmlns', SVG_NS);
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', '24');
  svg.setAttribute('height', '24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '2');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('class', 'lucide');

  for (const child of data) {
    const tag = child[0];
    const attrs = child[1] || {};
    if (typeof tag !== 'string') continue;
    const node = document.createElementNS(SVG_NS, tag);
    for (const key of Object.keys(attrs)) {
      node.setAttribute(key, String(attrs[key]));
    }
    svg.appendChild(node);
  }
  return svg;
}
